const CommandsEnum = {
  PING: 'Ping',
  CLEAN_OPEN_SALE: 'CleanOpenSale',
  REQUEST_LOGS: 'RequestLogs',
  TERMINAL_LIST_DEVICES: 'TerminalListDevices',
  TERMINAL_LIST_DEVICES_DEBUG: 'TerminalListDevicesDebug',
  REFRESH_PAYBOX_CONFIG: 'RefreshPayBoxConfig',
  SAT_CONSULT_STATUS: 'SatConsultStatus',
  SAT_EXTRACT_LOGS: 'SatExtractLogs',
  SAT_END_TO_END_TEST: 'SatEndToEndTest',
  TEF_INITIALIZE: 'TefInitialize',
  TEF_AUTHENTICATE: 'TefAuthenticate',
  TEF_REFRESH_TABLES: 'TefRefreshTables',
  ADJUST_DATE_AND_TIME: 'AdjustDateAndTime',
  KILL_SERVICES: 'KillServices',
  UPDATE_VERSIONS: 'UpdateVersions',
  GET_OPEN_SALE: 'GetOpenSale',
}

const payBoxCommandDomain = {
  data() {
    return {
      CommandsEnum,
    }
  },

  computed: {
    payBoxCommandsLabel() {
      return {
        [this.CommandsEnum.PING]: this.$t('Ping'),
        [this.CommandsEnum.TERMINAL_LIST_DEVICES_DEBUG]: this.$t(
          'Terminal | Listar periféricos (DEBUG)'
        ),
        [this.CommandsEnum.TERMINAL_LIST_DEVICES]: this.$t('Terminal | Listar periféricos'),
        [this.CommandsEnum.CLEAN_OPEN_SALE]: this.$t('Limpar Venda Aberta'),
        [this.CommandsEnum.REQUEST_LOGS]: this.$t('Solicitar logs'),
        [this.CommandsEnum.REFRESH_PAYBOX_CONFIG]: this.$t('Ler Configurações do Caixa'),
        [this.CommandsEnum.SAT_CONSULT_STATUS]: this.$t('Consultar Status do Sat'),
        [this.CommandsEnum.SAT_EXTRACT_LOGS]: this.$t('Extrair Logs do Sat'),
        [this.CommandsEnum.SAT_END_TO_END_TEST]: this.$t('Executar Teste Fim a Fim no Sat'),
        [this.CommandsEnum.TEF_INITIALIZE]: this.$t('Inicializar Tef'),
        [this.CommandsEnum.TEF_AUTHENTICATE]: this.$t('Autenticar Tef'),
        [this.CommandsEnum.TEF_REFRESH_TABLES]: this.$t('Atualizar Tabelas Tef'),
        [this.CommandsEnum.ADJUST_DATE_AND_TIME]: this.$t('Atualizar Data e Hora do Computador'),
        [this.CommandsEnum.KILL_SERVICES]: this.$t('Forçar Encerramento das Aplicações'),
        [this.CommandsEnum.UPDATE_VERSIONS]: this.$t('Atualizar Versões das Aplicações'),
        [this.CommandsEnum.GET_OPEN_SALE]: this.$t('Consultar a venda em aberto no PDV'),
      }
    },
    payBoxCommandsMessageConfirmationTemplate() {
      return {
        [this.CommandsEnum.PING]: this.$t('PAYBOX_COMMAND.PING'),
        [this.CommandsEnum.CLEAN_OPEN_SALE]: this.$t('PAYBOX_COMMAND.CLEAN_OPEN_SALE'),
        [this.CommandsEnum.REQUEST_LOGS]: this.$t('PAYBOX_COMMAND.REQUEST_LOGS'),
        [this.CommandsEnum.TERMINAL_LIST_DEVICES_DEBUG]: this.$t(
          'PAYBOX_COMMAND.TERMINAL_LIST_DEVICES_DEBUG'
        ),
        [this.CommandsEnum.TERMINAL_LIST_DEVICES]: this.$t('PAYBOX_COMMAND.TERMINAL_LIST_DEVICES'),
        [this.CommandsEnum.REFRESH_PAYBOX_CONFIG]: this.$t('PAYBOX_COMMAND.REFRESH_PAYBOX_CONFIG'),
        [this.CommandsEnum.SAT_CONSULT_STATUS]: this.$t('PAYBOX_COMMAND.SAT_CONSULT_STATUS'),
        [this.CommandsEnum.SAT_EXTRACT_LOGS]: this.$t('PAYBOX_COMMAND.SAT_EXTRACT_LOGS'),
        [this.CommandsEnum.SAT_END_TO_END_TEST]: this.$t('PAYBOX_COMMAND.SAT_END_TO_END_TEST'),
        [this.CommandsEnum.TEF_INITIALIZE]: this.$t('PAYBOX_COMMAND.TEF_INITIALIZE'),
        [this.CommandsEnum.TEF_AUTHENTICATE]: this.$t('PAYBOX_COMMAND.TEF_AUTHENTICATE'),
        [this.CommandsEnum.TEF_REFRESH_TABLES]: this.$t('PAYBOX_COMMAND.TEF_REFRESH_TABLES'),
        [this.CommandsEnum.ADJUST_DATE_AND_TIME]: this.$t('PAYBOX_COMMAND.ADJUST_DATE_AND_TIME'),
        [this.CommandsEnum.KILL_SERVICES]: this.$t('PAYBOX_COMMAND.KILL_SERVICES'),
        [this.CommandsEnum.UPDATE_VERSIONS]: this.$t('PAYBOX_COMMAND.UPDATE_VERSIONS'),
        [this.CommandsEnum.GET_OPEN_SALE]: this.$t('PAYBOX_COMMAND.GET_OPEN_SALE'),
      }
    },
  },

  methods: {
    payBoxCommandsOptions() {
      return [
        { value: CommandsEnum.PING, label: this.$t('PDV | Ping') },
        { value: CommandsEnum.CLEAN_OPEN_SALE, label: this.$t('PDV | Limpar Venda Aberta') },
        { value: CommandsEnum.REQUEST_LOGS, label: this.$t('PDV | Solicitar logs') },
        {
          value: CommandsEnum.REFRESH_PAYBOX_CONFIG,
          label: this.$t('PDV | Ler Configurações do caixa'),
        },
        { value: CommandsEnum.GET_OPEN_SALE, label: this.$t('PDV | Consultar venda em aberto') },
        { value: CommandsEnum.TEF_INITIALIZE, label: this.$t('TEF | Inicializar') },
        { value: CommandsEnum.TEF_AUTHENTICATE, label: this.$t('TEF | Autenticar') },
        { value: CommandsEnum.TEF_REFRESH_TABLES, label: this.$t('TEF | Atualizar Tabelas') },
        {
          value: CommandsEnum.ADJUST_DATE_AND_TIME,
          label: this.$t('TERMINAL | Atualizar Data e Hora do Computador'),
        },
        {
          value: CommandsEnum.KILL_SERVICES,
          label: this.$t('TERMINAL | Forçar Encerramento das Aplicações'),
        },
        {
          value: CommandsEnum.UPDATE_VERSIONS,
          label: this.$t('TERMINAL | Atualizar Versões das Aplicações'),
        },
        {
          value: CommandsEnum.TERMINAL_LIST_DEVICES_DEBUG,
          label: this.$t('TERMINAL | Listar periféricos (DEBUG)'),
        },
        {
          value: CommandsEnum.TERMINAL_LIST_DEVICES,
          label: this.$t('TERMINAL | Listar periféricos'),
        },
      ]
    },
  },
}

export default payBoxCommandDomain
